import QuizEducationMain from "../../../education/QuizEducationMain";

function QuizEducation({nextPage}){
    return <QuizEducationMain onComplete={() => nextPage("questions")} />
}

export default QuizEducation;